module.exports = __webpack_public_path__ + "img/regrets.89d5be4a.svg";